// extracted by mini-css-extract-plugin
export default {"uikit-plain-text":"uikit-plain-text__jc4P8"};